import Cookies from 'js-cookie'
import {identity, isEmpty, isEqual, keyBy} from 'lodash'
import queryString from 'query-string'
import {actionCreators} from 'actions'
import api from 'api'
import {formValueSelector, getFormValues, autofill as autofillForm} from 'redux-form'
import {groupFullName} from 'employees/form/EmploymentInfomation'

export const formName = 'tmUserSearchForm'
export const selector = formValueSelector(formName)
export const getValues = getFormValues(formName)
export const autofill = autofillForm.bind(null, formName)
export const defaultQuery = {
  _page: '1',
  sort: 'staff_code',
  order: 'asc',
}
const defaultLimit = '50'

export const convertQueryToForm = (query) => {
  return Object.assign(
    {sort_type: `${query.sort}__${query.order}`},
    ...Object.entries(query)
      .map(([k, v]) => convertQueryToFormField(k, v))
      .filter(identity)
  )
}

export const convertQueryToFormField = (fieldName, value) => {
  switch (fieldName) {
    case 'name':
      return {name: value.join(',')}
    case 'email':
      return {email: value.join(',')}
    case 'staff_code':
      return {staff_code: value.join(',')}
    case 'office_ids':
      return {offices: value.join(',')}
    case 'group_ids':
      return {groups: value.join(',')}
    case 'employment_status_ids':
      return {employment_statuses: value}
    case 'position_ids':
      return {positions: value}
    case 'tag_ids':
      return {tags: value.join(',')}
    case 'employment_type_ids':
      return {employment_types: value}
    case 'occupation_ids':
      return {occupations: value}
    case '_page':
      return {page: value}
    case 'sort':
    case 'order':
      return undefined
    default:
      return {[fieldName]: value}
  }
}

export const convertFormToQueryString = (data) =>
  queryString.stringify(convertFormToQuery(data), {arrayFormat: 'bracket'})

export const convertFormToQuery = (data) => {
  if (data === undefined) return {}
  return Object.assign(
    {},
    ...Object.entries(data)
      .map(([k, v]) => convertFormToQueryField(k, v))
      .filter(identity)
  )
}

export const convertFormToQueryField = (fieldName, value) => {
  switch (fieldName) {
    case 'name': {
      return !isEmpty(value) ? {name: value.split(/,|\s/)} : null
    }
    case 'email': {
      return !isEmpty(value) ? {email: value.split(/,|\s/)} : null
    }
    case 'staff_code': {
      return !isEmpty(value) ? {staff_code: value.split(/,|\s/)} : null
    }
    case 'offices': {
      const officesIds = value.split(',')
      return !isEqual(officesIds, ['']) ? {office_ids: officesIds} : null
    }
    case 'groups': {
      const groupIds = value.split(',')
      return !isEqual(groupIds, ['']) ? {group_ids: groupIds} : null
    }
    case 'tags': {
      const tagIds = value.split(',')
      return !isEqual(tagIds, ['']) ? {tag_ids: tagIds} : null
    }
    case 'employment_statuses':
      return !isEmpty(value) ? {employment_status_ids: value} : null
    case 'positions':
      return !isEmpty(value) ? {position_ids: value} : null
    case 'employment_types':
      return !isEmpty(value) ? {employment_type_ids: value} : null
    case 'occupations':
      return !isEmpty(value) ? {occupation_ids: value} : null
    case 'limit':
      return null
    case 'page':
      return {_page: value}
    case 'sort_type': {
      const [sort, order] = value.split('__')
      return {order, sort}
    }
    default:
      return {[fieldName]: value}
  }
}

export const getCurrentQueryFromLocation = (location, user) => {
  return {
    ...defaultQuery,
    ...queryString.parse(location.search, {arrayFormat: 'bracket'}),
    limit: getSavedDisplayEmployeeLimit(location.pathname, user),
  }
}

const limitKey = (pathname, user) => `${pathname.replace(/\//g, '')}#${user.id}__disp_emp_limit`

export const getSavedDisplayEmployeeLimit = (pathname, user) => {
  if (window.localStorage) {
    const limit = window.localStorage.getItem(limitKey(pathname, user))
    if (!isEmpty(limit)) {
      return limit
    }
  }
  const limit = Cookies.get(limitKey(pathname, user))
  return isEmpty(limit) ? defaultLimit : limit
}

export const saveDisplayEmployeeLimit = (pathname, user, limit) => {
  if (window.localStorage) {
    window.localStorage.setItem(limitKey(pathname, user), limit)
  } else {
    Cookies.set(limitKey(pathname, user), limit)
  }
}

export const fetchEmployees =
  (query, additionalParams = {}) =>
  (dispatch, getState) => {
    const {
      auth: {token},
    } = getState()
    const request = api.createWithAuth(token).employees.search({...query, ...additionalParams})
    dispatch(actionCreators.employees.list.fetchData(request))
  }

// MEMO: Layout呼び出し時に最新のofficeが取得されているのでここで再度取得する必要はない
export const fetchSelections = (token, dispatch) => {
  const promises = [
    api.createWithAuth(token).groups.list(),
    api.createWithAuth(token).employees.selections.positions(),
    api.createWithAuth(token).employees.selections.employmentTypes(),
    api.createWithAuth(token).employees.selections.occupations(),
    api.createWithAuth(token).employees.selections.tags(),
  ]
  dispatch(
    actionCreators.fetchData(
      'selections',
      Promise.all(promises).then((results) => {
        const [groupsResult, positionsResult, employmentTypesResult, occupationsResult, tagsResult] = results
        return {
          groups: groupsResult.groups.map((group) => ({
            value: `${group.id}`,
            label: groupFullName(group, keyBy(groupsResult.groups, 'id')),
            parent_value: `${group.parent_group_id}`,
          })),
          positions: positionsResult.data.map((item) => ({...item, id: `${item.id}`})),
          employmentTypes: employmentTypesResult.data.map((item) => ({...item, id: `${item.id}`})),
          occupations: occupationsResult.data.map((item) => ({...item, id: `${item.id}`})),
          tags: tagsResult.data.map((tag) => ({
            value: `${tag.id}`,
            label: tag.name,
          })),
        }
      })
    )
  )
}
